import PageWrapperComponent from "@src/components/organisms/page-wrapper/page-wrapper.component";
import React from "react";

const AttendanceTemplate = () => {
  return <PageWrapperComponent>Test</PageWrapperComponent>;
};

export default AttendanceTemplate;
